
export const UI_ART = "/ui";
export const GAME_ART = "/ui/game";

export const TEXTURE_ART = "/ui/textures";

/** `ui.ThinBoard.CORNER_WIDTH` (`root/ui.py:1833-1836`). */
export const BOARD_SLICE = 16;

/** `ui.Board.CORNER_WIDTH` / `CORNER_HEIGHT` (`root/ui.py:1694-1695`). */
export const BOARD_CORNER = 32;

/** `ui.ThinBoard.BOARD_COLOR` (`root/ui.py:1837`). */
export const BOARD_FILL = "rgba(0, 0, 0, 0.51)";

/** `ui.TitleBar.BLOCK_WIDTH` / `BLOCK_HEIGHT` (`root/ui.py:1512-1513`). */
export const TITLEBAR_BLOCK = 32;
export const TITLEBAR_HEIGHT = 23;

/** `ui.HorizontalBar.BLOCK_WIDTH` / `BLOCK_HEIGHT` (`root/ui.py:1583-1584`),
 *  and the floor `Create` puts under a requested width (`root/ui.py:1595`). */
export const HBAR_BLOCK = 32;
export const HBAR_HEIGHT = 17;
export const HBAR_MIN_WIDTH = 96;

/** `ui.Gauge.SLOT_WIDTH` / `SLOT_HEIGHT` (`root/ui.py:1628-1629`). */
export const GAUGE_SLOT_WIDTH = 16;
export const GAUGE_SLOT_HEIGHT = 7;

/** `ui.Gauge.GAUGE_TEMPORARY_PLACE` (`root/ui.py:1631`): where the coloured
 *  fill starts, and by symmetry (`SetPercentage`, `root/ui.py:1689`) how much
 *  of the slot at each end is cap rather than fill. */
export const GAUGE_INSET = 12;

/** `ui.ScrollBar.SCROLLBAR_WIDTH` / `SCROLLBAR_BUTTON_HEIGHT`
 *  (`root/ui.py:1927`, `:1930`). */
export const SCROLLBAR_WIDTH = 17;
export const SCROLLBAR_BUTTON_HEIGHT = 17;

export const CHROME_ASSETS = {
  thinboard: `${UI_ART}/thinboard.png`,
  board: `${GAME_ART}/board.png`,
  titlebar: `${GAME_ART}/titlebar.png`,
  slotBase: `${TEXTURE_ART}/public/slot_base.png`,
  equipmentBg: `${TEXTURE_ART}/equipment_bg_without_ring.png`,
  close: `${TEXTURE_ART}/public/close_button_01.png`,
  closeOver: `${TEXTURE_ART}/public/close_button_02.png`,
  closeDown: `${TEXTURE_ART}/public/close_button_03.png`,
  xlarge: `${TEXTURE_ART}/public/xlarge_button_01.png`,
  xlargeOver: `${TEXTURE_ART}/public/xlarge_button_02.png`,
  xlargeDown: `${TEXTURE_ART}/public/xlarge_button_03.png`,
  large: `${UI_ART}/button_large.png`,
  largeOver: `${UI_ART}/button_large_over.png`,
  largeDown: `${UI_ART}/button_large_down.png`,
  costume: `${TEXTURE_ART}/game/costume_button_01.png`,
  costumeOver: `${TEXTURE_ART}/game/costume_button_02.png`,
  costumeDown: `${TEXTURE_ART}/game/costume_button_03.png`,
  mall: `${GAME_ART}/mall_button_01.png`,
  mallOver: `${GAME_ART}/mall_button_02.png`,
  mallDown: `${GAME_ART}/mall_button_03.png`,
  letterClose: `${GAME_ART}/quest_letter_close.png`,
  letterOpen: `${GAME_ART}/quest_letter_open.png`,
  dss: `${TEXTURE_ART}/dragonsoul/dss_inventory_button_01.png`,
  dssOver: `${TEXTURE_ART}/dragonsoul/dss_inventory_button_02.png`,
  dssDown: `${TEXTURE_ART}/dragonsoul/dss_inventory_button_03.png`,

  // `ui.Board`'s nine pieces (`root/ui.py:1720-1729`, `:1759`).
  boardCornerLT: `${TEXTURE_ART}/pattern/board_corner_lefttop.png`,
  boardCornerRT: `${TEXTURE_ART}/pattern/board_corner_righttop.png`,
  boardCornerLB: `${TEXTURE_ART}/pattern/board_corner_leftbottom.png`,
  boardCornerRB: `${TEXTURE_ART}/pattern/board_corner_rightbottom.png`,
  boardLineL: `${TEXTURE_ART}/pattern/board_line_left.png`,
  boardLineR: `${TEXTURE_ART}/pattern/board_line_right.png`,
  boardLineT: `${TEXTURE_ART}/pattern/board_line_top.png`,
  boardLineB: `${TEXTURE_ART}/pattern/board_line_bottom.png`,
  boardBase: `${TEXTURE_ART}/pattern/board_base.png`,

  // `ui.ThinBoard`'s eight (`root/ui.py:1851-1852`); the ninth is `BOARD_FILL`.
  thinCornerLT: `${TEXTURE_ART}/pattern/thinboard_corner_lefttop.png`,
  thinCornerRT: `${TEXTURE_ART}/pattern/thinboard_corner_righttop.png`,
  thinCornerLB: `${TEXTURE_ART}/pattern/thinboard_corner_leftbottom.png`,
  thinCornerRB: `${TEXTURE_ART}/pattern/thinboard_corner_rightbottom.png`,
  thinLineL: `${TEXTURE_ART}/pattern/thinboard_line_left.png`,
  thinLineR: `${TEXTURE_ART}/pattern/thinboard_line_right.png`,
  thinLineT: `${TEXTURE_ART}/pattern/thinboard_line_top.png`,
  thinLineB: `${TEXTURE_ART}/pattern/thinboard_line_bottom.png`,

  // `ui.TitleBar` (`root/ui.py:1543-1545`).
  titlebarLeft: `${TEXTURE_ART}/pattern/titlebar_left.png`,
  titlebarCenter: `${TEXTURE_ART}/pattern/titlebar_center.png`,
  titlebarRight: `${TEXTURE_ART}/pattern/titlebar_right.png`,

  // `ui.HorizontalBar.Create` (`root/ui.py:1600-1612`).
  hbarLeft: `${TEXTURE_ART}/pattern/horizontalbar_left.png`,
  hbarCenter: `${TEXTURE_ART}/pattern/horizontalbar_center.png`,
  hbarRight: `${TEXTURE_ART}/pattern/horizontalbar_right.png`,

  // `ui.Gauge` (`root/ui.py:1646-1664`).
  gaugeSlotLeft: `${TEXTURE_ART}/pattern/gauge_slot_left.png`,
  gaugeSlotCenter: `${TEXTURE_ART}/pattern/gauge_slot_center.png`,
  gaugeSlotRight: `${TEXTURE_ART}/pattern/gauge_slot_right.png`,
  gaugeRed: `${TEXTURE_ART}/pattern/gauge_red.png`,
  gaugeBlue: `${TEXTURE_ART}/pattern/gauge_blue.png`,
  gaugePurple: `${TEXTURE_ART}/pattern/gauge_purple.png`,
  gaugePink: `${TEXTURE_ART}/pattern/gauge_pink.png`,

  // `ui.ScrollBar` (`root/ui.py:1945-1957`, `:2005-2015`).
  scrollTop: `${TEXTURE_ART}/pattern/scrollbar_top.png`,
  scrollMiddle: `${TEXTURE_ART}/pattern/scrollbar_middle.png`,
  scrollBottom: `${TEXTURE_ART}/pattern/scrollbar_bottom.png`,
  scrollUp: `${TEXTURE_ART}/public/scrollbar_up_button_01.png`,
  scrollUpOver: `${TEXTURE_ART}/public/scrollbar_up_button_02.png`,
  scrollUpDown: `${TEXTURE_ART}/public/scrollbar_up_button_03.png`,
  scrollDown: `${TEXTURE_ART}/public/scrollbar_down_button_01.png`,
  scrollDownOver: `${TEXTURE_ART}/public/scrollbar_down_button_02.png`,
  scrollDownDown: `${TEXTURE_ART}/public/scrollbar_down_button_03.png`,

  largeUp: `${TEXTURE_ART}/public/large_button_01.png`,
  largeOverState: `${TEXTURE_ART}/public/large_button_02.png`,
  largeDownState: `${TEXTURE_ART}/public/large_button_03.png`,
  middleUp: `${TEXTURE_ART}/public/middle_button_01.png`,
  middleOver: `${TEXTURE_ART}/public/middle_button_02.png`,
  middleDown: `${TEXTURE_ART}/public/middle_button_03.png`,
  smallUp: `${TEXTURE_ART}/public/small_button_01.png`,
  smallOver: `${TEXTURE_ART}/public/small_button_02.png`,
  smallDown: `${TEXTURE_ART}/public/small_button_03.png`,
  slotCover: `${TEXTURE_ART}/public/slot_cover_button_01.png`,
  slotCoverOver: `${TEXTURE_ART}/public/slot_cover_button_02.png`,
  slotCoverDown: `${TEXTURE_ART}/public/slot_cover_button_03.png`,
  slotCoverDisabled: `${TEXTURE_ART}/public/slot_cover_button_04.png`,
} as const;

const STYLE_ID = "m2-chrome-style";

export const CHROME_CSS = `
.m2-board,
.m2-thinboard {
  box-sizing: border-box;
  /* Transparent, not removed: the 1px border was invented chrome, but taking
     the width away would move every panel's content box by two pixels and the
     layout metrics belong to the panels, not here. */
  border: 1px solid transparent;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.55);
  border-radius: 0;
  font-family: Tahoma, "Segoe UI", sans-serif;
  color: #e8dcc0;
  /* ui.Board: four 32x32 corners pinned to the corners, four 128-long edges and
     a 128x128 base tiled between them (root/ui.py:1720-1729, :1759, :1774-1787).
     Corners first so they paint over the edges they overlap. */
  background-image:
    url("${CHROME_ASSETS.boardCornerLT}"),
    url("${CHROME_ASSETS.boardCornerRT}"),
    url("${CHROME_ASSETS.boardCornerLB}"),
    url("${CHROME_ASSETS.boardCornerRB}"),
    url("${CHROME_ASSETS.boardLineT}"),
    url("${CHROME_ASSETS.boardLineB}"),
    url("${CHROME_ASSETS.boardLineL}"),
    url("${CHROME_ASSETS.boardLineR}"),
    url("${CHROME_ASSETS.boardBase}");
  background-repeat:
    no-repeat, no-repeat, no-repeat, no-repeat,
    repeat-x, repeat-x, repeat-y, repeat-y, repeat;
  background-position:
    left top, right top, left bottom, right bottom,
    ${BOARD_CORNER}px top, ${BOARD_CORNER}px bottom,
    left ${BOARD_CORNER}px, right ${BOARD_CORNER}px,
    ${BOARD_CORNER}px ${BOARD_CORNER}px;
  background-origin: border-box;
  background-clip: border-box;
  background-color: transparent;
}
.m2-thinboard {
  /* ui.ThinBoard: the same nine at 16 (root/ui.py:1851-1852) over a flat
     51% black Bar (:1837, :1876-1881) -- that Bar is background-color. */
  background-image:
    url("${CHROME_ASSETS.thinCornerLT}"),
    url("${CHROME_ASSETS.thinCornerRT}"),
    url("${CHROME_ASSETS.thinCornerLB}"),
    url("${CHROME_ASSETS.thinCornerRB}"),
    url("${CHROME_ASSETS.thinLineT}"),
    url("${CHROME_ASSETS.thinLineB}"),
    url("${CHROME_ASSETS.thinLineL}"),
    url("${CHROME_ASSETS.thinLineR}");
  background-repeat:
    no-repeat, no-repeat, no-repeat, no-repeat,
    repeat-x, repeat-x, repeat-y, repeat-y;
  background-position:
    left top, right top, left bottom, right bottom,
    ${BOARD_SLICE}px top, ${BOARD_SLICE}px bottom,
    left ${BOARD_SLICE}px, right ${BOARD_SLICE}px;
  background-color: ${BOARD_FILL};
}
.m2-titlebar {
  position: absolute;
  /* BoardWithTitleBar: SetPosition(8, 7) (root/ui.py:1796) and
     SetWidth(width - 15) (root/ui.py:1816), so the bar's right edge is 7px in --
     not 28. At 28 the bar's own painted close-button well sat 21px left of the
     .m2-close that fills it, and the panel showed two crosses side by side. */
  left: 8px;
  top: 7px;
  right: 7px;
  z-index: 3;
  height: ${TITLEBAR_HEIGHT}px;
  /* ui.TitleBar: left | centre tiled | right, 32-wide blocks 23 tall
     (root/ui.py:1512-1513, :1543-1545, SetWidth at :1566-1575). The .tga files
     are 32 tall with nine transparent rows the 23px box clips off. */
  background-image:
    url("${CHROME_ASSETS.titlebarLeft}"),
    url("${CHROME_ASSETS.titlebarRight}"),
    url("${CHROME_ASSETS.titlebarCenter}");
  background-repeat: no-repeat, no-repeat, repeat-x;
  background-position: left top, right top, ${TITLEBAR_BLOCK}px top;
  background-color: transparent;
  border: 0;
  color: #e8c877;
  font: 700 12px/21px Tahoma, "Segoe UI", sans-serif;
  text-align: center;
  letter-spacing: 0.02em;
  text-transform: none;
  cursor: grab;
  user-select: none;
  -webkit-user-select: none;
  touch-action: none;
  pointer-events: auto;
}
.m2-titlebar:active { cursor: grabbing; }
.m2-close {
  position: absolute;
  top: 10px;
  right: 10px;
  /* OPEN BUG: .m2-titlebar above is z-index 3 and spans 7..28px vertically, so
     it covers this 10..24px cross on every panel that uses this chrome -- a
     click on the close button is intercepted by the drag bar ("shop-title
     intercepts pointer events", Playwright). tools/e2e/playthrough.mjs swallows
     that failure with a .catch, so no check has ever seen the close button
     work. Raising this above 3 is the fix; measure the drag first. */
  z-index: 2;
  width: 16px;
  height: 14px;
  padding: 0;
  border: 0;
  background: url("${CHROME_ASSETS.close}") center / contain no-repeat;
  cursor: pointer;
  color: transparent;
}
.m2-close:hover { background-image: url("${CHROME_ASSETS.closeOver}"); }
.m2-close:active { background-image: url("${CHROME_ASSETS.closeDown}"); }
.m2-xlarge {
  width: 180px;
  height: 26px;
  padding: 0;
  border: 0;
  background: url("${CHROME_ASSETS.xlarge}") center / 100% 100% no-repeat;
  color: #ead7ae;
  font: 12px/26px Tahoma, "Segoe UI", sans-serif;
  cursor: pointer;
}
.m2-xlarge:hover { background-image: url("${CHROME_ASSETS.xlargeOver}"); }
.m2-xlarge:active { background-image: url("${CHROME_ASSETS.xlargeDown}"); }
.m2-slot {
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  background: url("${CHROME_ASSETS.slotBase}") center / 32px 32px no-repeat;
  image-rendering: pixelated;
}
/* ui.SlotWindow.SetCoverButton (root/ui.py:1267-1275): the plate that lies over
   a slot, in the four states the defaults name -- up, over, down, disabled. */
.m2-slot-cover {
  position: absolute;
  inset: 0;
  padding: 0;
  border: 0;
  background: url("${CHROME_ASSETS.slotCover}") center / 32px 32px no-repeat;
  image-rendering: pixelated;
  cursor: pointer;
}
.m2-slot-cover:hover { background-image: url("${CHROME_ASSETS.slotCoverOver}"); }
.m2-slot-cover:active { background-image: url("${CHROME_ASSETS.slotCoverDown}"); }
/* The plate lies over the slot rather than being it, so it is a span and its
   fourth face hangs off aria-disabled rather than off :disabled. */
.m2-slot-cover[aria-disabled="true"] {
  background-image: url("${CHROME_ASSETS.slotCoverDisabled}");
  cursor: default;
}

/* The three d:/ymir work/ui/public/ button families, each a default/over/down
   triple exactly as a layout names it: large is 88x21
   (uiscript/uiscript/mallwindow.py:58-60), middle 61x21
   (uiscript/uiscript/attachstonedialog.py:102-104), small 43x21
   (uiscript/uiscript/declareguildwardialog.py:81-83). The sizes are the
   sprites' own, from client/public/ui/ui_textures.json. */
.m2-large,
.m2-middle,
.m2-small {
  padding: 0;
  border: 0;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  color: #ead7ae;
  font-family: Tahoma, "Segoe UI", sans-serif;
  font-size: 12px;
  cursor: pointer;
  image-rendering: pixelated;
}
.m2-large { width: 88px; height: 21px; line-height: 21px; background-image: url("${CHROME_ASSETS.largeUp}"); }
.m2-large:hover { background-image: url("${CHROME_ASSETS.largeOverState}"); }
.m2-large:active { background-image: url("${CHROME_ASSETS.largeDownState}"); }
.m2-middle { width: 61px; height: 21px; line-height: 21px; background-image: url("${CHROME_ASSETS.middleUp}"); }
.m2-middle:hover { background-image: url("${CHROME_ASSETS.middleOver}"); }
.m2-middle:active { background-image: url("${CHROME_ASSETS.middleDown}"); }
.m2-small { width: 43px; height: 21px; line-height: 21px; background-image: url("${CHROME_ASSETS.smallUp}"); }
.m2-small:hover { background-image: url("${CHROME_ASSETS.smallOver}"); }
.m2-small:active { background-image: url("${CHROME_ASSETS.smallDown}"); }

/* ui.HorizontalBar (root/ui.py:1581-1623): a 32-wide left cap, a 32-wide right
   cap at width-32 and the centre stretched between them, over a box
   BLOCK_HEIGHT tall (root/ui.py:1584) and never narrower than 96 (:1595). The
   section heading sits on it, which is how the pack labels a group. */
.m2-hbar {
  min-width: ${HBAR_MIN_WIDTH}px;
  height: ${HBAR_HEIGHT}px;
  background-image:
    url("${CHROME_ASSETS.hbarLeft}"),
    url("${CHROME_ASSETS.hbarRight}"),
    url("${CHROME_ASSETS.hbarCenter}");
  background-repeat: no-repeat, no-repeat, repeat-x;
  background-position: left top, right top, ${HBAR_BLOCK}px top;
  image-rendering: pixelated;
}

/* ui.Gauge.MakeGauge (root/ui.py:1646-1665): a 16-wide left cap at 0, a 16-wide
   right cap at width-16, and the centre tiled between them. The .tga files are
   16x8 with the bottom row transparent; SLOT_HEIGHT is 7 (root/ui.py:1629). */
.m2-gauge {
  position: relative;
  height: ${GAUGE_SLOT_HEIGHT}px;
  background-image:
    url("${CHROME_ASSETS.gaugeSlotLeft}"),
    url("${CHROME_ASSETS.gaugeSlotRight}"),
    url("${CHROME_ASSETS.gaugeSlotCenter}");
  background-repeat: no-repeat, no-repeat, repeat-x;
  background-position: left top, right top, ${GAUGE_SLOT_WIDTH}px top;
  background-color: transparent;
  border: 0;
  overflow: hidden;
  image-rendering: pixelated;
}
/* GAUGE_TEMPORARY_PLACE (root/ui.py:1631) puts the coloured bar 12px in, and
   SetPercentage (:1689) scales it over width - GAUGE_TEMPORARY_PLACE*2 -- so
   the fill lives inside a box inset 12px at each end and 0-100% wide in it. */
.m2-gauge-fill {
  position: absolute;
  left: ${GAUGE_INSET}px;
  right: ${GAUGE_INSET}px;
  top: 0;
  bottom: 0;
}
.m2-gauge-fill::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: var(--m2-gauge-percent, 0%);
  background: url("${CHROME_ASSETS.gaugeRed}") left top repeat-x;
  image-rendering: pixelated;
}
.m2-gauge-blue .m2-gauge-fill::after { background-image: url("${CHROME_ASSETS.gaugeBlue}"); }
.m2-gauge-purple .m2-gauge-fill::after { background-image: url("${CHROME_ASSETS.gaugePurple}"); }
.m2-gauge-pink .m2-gauge-fill::after { background-image: url("${CHROME_ASSETS.gaugePink}"); }

/* ui.ScrollBar (root/ui.py:1927-1930, :1945-1957, :2005-2015): a 17-wide track
   whose top/middle/bottom pieces are 16x4 tiles, and an up and a down button in
   three states each. Applied to anything that scrolls inside a shared board. */
.m2-board ::-webkit-scrollbar,
.m2-thinboard ::-webkit-scrollbar,
.m2-scroll::-webkit-scrollbar {
  width: ${SCROLLBAR_WIDTH}px;
}
.m2-board ::-webkit-scrollbar-track,
.m2-thinboard ::-webkit-scrollbar-track,
.m2-scroll::-webkit-scrollbar-track {
  background: url("${CHROME_ASSETS.scrollMiddle}") left top repeat-y;
  image-rendering: pixelated;
}
.m2-board ::-webkit-scrollbar-thumb,
.m2-thinboard ::-webkit-scrollbar-thumb,
.m2-scroll::-webkit-scrollbar-thumb {
  background-image:
    url("${CHROME_ASSETS.scrollTop}"),
    url("${CHROME_ASSETS.scrollBottom}"),
    url("${CHROME_ASSETS.scrollMiddle}");
  background-repeat: no-repeat, no-repeat, repeat-y;
  background-position: left top, left bottom, left top;
  image-rendering: pixelated;
}
.m2-board ::-webkit-scrollbar-button:vertical:decrement,
.m2-thinboard ::-webkit-scrollbar-button:vertical:decrement,
.m2-scroll::-webkit-scrollbar-button:vertical:decrement {
  height: ${SCROLLBAR_BUTTON_HEIGHT}px;
  background: url("${CHROME_ASSETS.scrollUp}") center / contain no-repeat;
}
.m2-board ::-webkit-scrollbar-button:vertical:increment,
.m2-thinboard ::-webkit-scrollbar-button:vertical:increment,
.m2-scroll::-webkit-scrollbar-button:vertical:increment {
  height: ${SCROLLBAR_BUTTON_HEIGHT}px;
  background: url("${CHROME_ASSETS.scrollDown}") center / contain no-repeat;
}
/* Both arrows in the over and down face ui.ScrollBar gives them
   (root/ui.py:2006-2007, :2014-2015). */
.m2-board ::-webkit-scrollbar-button:vertical:decrement:hover,
.m2-thinboard ::-webkit-scrollbar-button:vertical:decrement:hover,
.m2-scroll::-webkit-scrollbar-button:vertical:decrement:hover {
  background-image: url("${CHROME_ASSETS.scrollUpOver}");
}
.m2-board ::-webkit-scrollbar-button:vertical:decrement:active,
.m2-thinboard ::-webkit-scrollbar-button:vertical:decrement:active,
.m2-scroll::-webkit-scrollbar-button:vertical:decrement:active {
  background-image: url("${CHROME_ASSETS.scrollUpDown}");
}
.m2-board ::-webkit-scrollbar-button:vertical:increment:hover,
.m2-thinboard ::-webkit-scrollbar-button:vertical:increment:hover,
.m2-scroll::-webkit-scrollbar-button:vertical:increment:hover {
  background-image: url("${CHROME_ASSETS.scrollDownOver}");
}
.m2-board ::-webkit-scrollbar-button:vertical:increment:active,
.m2-thinboard ::-webkit-scrollbar-button:vertical:increment:active,
.m2-scroll::-webkit-scrollbar-button:vertical:increment:active {
  background-image: url("${CHROME_ASSETS.scrollDownDown}");
}
.m2-scroll { scrollbar-width: thin; }
`;

export function installStyleSheet(doc: Document, id: string, css: string): void {
  if (doc.getElementById(id) !== null) return;
  const style = doc.createElement("style");
  style.id = id;
  style.textContent = css;
  doc.head.append(style);
}

export function styleInstaller(
  id: string,
  css: string,
  before?: (doc: Document) => void,
): (doc: Document) => void {
  return (doc: Document): void => {
    before?.(doc);
    installStyleSheet(doc, id, css);
  };
}

export function elem<K extends keyof HTMLElementTagNameMap>(
  doc: Document,
  tag: K,
  className: string,
  text?: string,
): HTMLElementTagNameMap[K] {
  const node = doc.createElement(tag);
  node.className = className;
  if (text !== undefined) node.textContent = text;
  return node;
}

export function installChrome(doc: Document): void {
  installStyleSheet(doc, STYLE_ID, CHROME_CSS);
}

export function makeDraggable(root: HTMLElement, handle: HTMLElement): void {
  let drag: { ox: number; oy: number; sl: number; st: number; pointerId: number } | null = null;
  const view = root.ownerDocument.defaultView;

  const onMove = (event: PointerEvent): void => {
    if (drag === null || event.pointerId !== drag.pointerId) return;
    const vw = view?.innerWidth ?? 1024;
    const vh = view?.innerHeight ?? 768;
    const width = root.getBoundingClientRect().width;
    let left = drag.sl + (event.clientX - drag.ox);
    let top = drag.st + (event.clientY - drag.oy);
    left = Math.max(0, Math.min(left, Math.max(0, vw - Math.min(width, vw))));
    top = Math.max(0, Math.min(top, vh - 32));
    root.style.left = `${Math.round(left)}px`;
    root.style.top = `${Math.round(top)}px`;
    root.style.right = "auto";
    root.style.bottom = "auto";
    root.style.transform = "none";
  };

  const endDrag = (event?: PointerEvent): void => {
    if (drag === null) return;
    if (event !== undefined && event.pointerId !== drag.pointerId) return;
    drag = null;
    handle.style.cursor = "grab";
    if (view !== null) {
      view.removeEventListener("pointermove", onMove);
      view.removeEventListener("pointerup", endDrag);
      view.removeEventListener("pointercancel", endDrag);
    }
  };

  handle.style.cursor = "grab";
  handle.addEventListener("pointerdown", (event) => {
    if (event.button !== 0) return;
    const target = event.target;
    if (target instanceof Element && target.closest("button, a, input, textarea, select")) {
      return;
    }
    const rect = root.getBoundingClientRect();
    drag = {
      ox: event.clientX,
      oy: event.clientY,
      sl: rect.left,
      st: rect.top,
      pointerId: event.pointerId,
    };
    if (typeof handle.setPointerCapture === "function") {
      try {
        handle.setPointerCapture(event.pointerId);
      } catch {
        // Safari may reject capture; window listeners below still drive the drag.
      }
    }
    handle.style.cursor = "grabbing";
    if (view !== null) {
      view.addEventListener("pointermove", onMove);
      view.addEventListener("pointerup", endDrag);
      view.addEventListener("pointercancel", endDrag);
    }
    event.preventDefault();
  });
  handle.addEventListener("pointermove", onMove);
  handle.addEventListener("pointerup", endDrag);
  handle.addEventListener("pointercancel", endDrag);
}

export interface ResizeOptions {
  /** The window's own floor, in CSS pixels. */
  readonly minWidth?: number;
  readonly minHeight?: number;
  /** `1` when dragging right grows the box; `0` for the original's
   *  `restrict_x` (`uichat.py:519`), which pins the axis entirely. */
  readonly growX?: 0 | 1;
  /** `1` when dragging down grows the box (a bottom edge or corner); `-1` for
   *  a grip on the top edge of a box anchored at its foot. */
  readonly growY?: -1 | 0 | 1;
  /** The `cursor:` value while the pointer is over the grip. */
  readonly cursor?: string;
  readonly anchor?: boolean;
  /** Called with the size actually applied, after it is applied. */
  readonly onResize?: (width: number, height: number) => void;
}

export function makeResizable(
  root: HTMLElement,
  grip: HTMLElement,
  options: ResizeOptions = {},
): void {
  const growX = options.growX ?? 1;
  const growY = options.growY ?? 1;
  const minWidth = options.minWidth ?? 0;
  const minHeight = options.minHeight ?? 0;
  const view = root.ownerDocument.defaultView;
  if (options.cursor !== undefined) grip.style.cursor = options.cursor;

  let drag: { ox: number; oy: number; w: number; h: number; pointerId: number } | null = null;

  const onMove = (event: PointerEvent): void => {
    if (drag === null || event.pointerId !== drag.pointerId) return;
    const vw = view?.innerWidth ?? 1024;
    const vh = view?.innerHeight ?? 768;
    const width = Math.min(
      Math.max(minWidth, drag.w + (event.clientX - drag.ox) * growX),
      Math.max(minWidth, vw),
    );
    const height = Math.min(
      Math.max(minHeight, drag.h + (event.clientY - drag.oy) * growY),
      Math.max(minHeight, vh),
    );
    if (growX !== 0) {
      root.style.width = `${Math.round(width)}px`;
      root.style.minWidth = `${Math.round(width)}px`;
      root.style.maxWidth = `${Math.round(width)}px`;
    }
    if (growY !== 0) {
      root.style.height = `${Math.round(height)}px`;
      root.style.minHeight = `${Math.round(height)}px`;
      root.style.maxHeight = `${Math.round(height)}px`;
    }
    options.onResize?.(Math.round(width), Math.round(height));
    event.preventDefault();
  };

  const endDrag = (event?: PointerEvent): void => {
    if (drag === null) return;
    if (event !== undefined && event.pointerId !== drag.pointerId) return;
    drag = null;
    if (view !== null) {
      view.removeEventListener("pointermove", onMove);
      view.removeEventListener("pointerup", endDrag);
      view.removeEventListener("pointercancel", endDrag);
    }
  };

  grip.addEventListener("pointerdown", (event) => {
    if (event.button !== 0) return;
    const rect = root.getBoundingClientRect();
    if (options.anchor === true) {
      const vh = view?.innerHeight ?? 768;
      if (growX !== 0) {
        root.style.left = `${Math.round(rect.left)}px`;
        root.style.right = "auto";
      }
      if (growY > 0) {
        root.style.top = `${Math.round(rect.top)}px`;
        root.style.bottom = "auto";
      } else if (growY < 0) {
        root.style.bottom = `${Math.round(vh - rect.bottom)}px`;
        root.style.top = "auto";
      }
      root.style.transform = "none";
    }
    drag = {
      ox: event.clientX,
      oy: event.clientY,
      w: rect.width,
      h: rect.height,
      pointerId: event.pointerId,
    };
    if (typeof grip.setPointerCapture === "function") {
      try {
        grip.setPointerCapture(event.pointerId);
      } catch {
        // Safari may reject capture; the window listeners below still drive it.
      }
    }
    if (view !== null) {
      view.addEventListener("pointermove", onMove);
      view.addEventListener("pointerup", endDrag);
      view.addEventListener("pointercancel", endDrag);
    }
    event.preventDefault();
    event.stopPropagation();
  });
  grip.addEventListener("pointermove", onMove);
  grip.addEventListener("pointerup", endDrag);
  grip.addEventListener("pointercancel", endDrag);
}

/** `RenderCoolTimeBox`'s rim, anticlockwise on screen from the top-left corner, in units of
 *  the slot's half-width (`PythonGraphic.cpp:500-510`). */
const COOL_TIME_RIM: readonly (readonly [number, number])[] = [
  [-1, -1], [-1, 0], [-1, 1], [0, 1], [1, 1], [1, 0], [1, -1], [0, -1],
];

/** The half-black fan `CPythonGraphic::RenderCoolTimeBox` draws over a cooling
 *  slot (`PythonGraphic.cpp:491-574`), as a CSS polygon over the whole cell, for
 *  `elapsed` the fraction of the cool time gone; null once it is over. */
export function coolTimeBoxPolygon(elapsed: number): string | null {
  if (elapsed >= 1) return null; // PythonGraphic.cpp:493-494
  const time = Math.max(0, elapsed); // PythonGraphic.cpp:496
  const sweep = 8 - 8 * time;
  const whole = Math.trunc(sweep); // PythonGraphic.cpp:512
  const last = sweep - whole; // PythonGraphic.cpp:513
  const points: [number, number][] = [[0, 0], [0, -1]];
  for (let j = 0; j < whole; j++) points.push([...COOL_TIME_RIM[j]]);
  if (last > 0) {
    const from = COOL_TIME_RIM[(whole - 1 + 8) % 8]; // PythonGraphic.cpp:546
    const to = COOL_TIME_RIM[whole % 8]; // PythonGraphic.cpp:547
    points.push([from[0] + (to[0] - from[0]) * last, from[1] + (to[1] - from[1]) * last]);
  }
  const pct = (v: number): string => `${String(50 + 50 * v)}%`;
  return `polygon(${points.map(([x, y]) => `${pct(x)} ${pct(y)}`).join(", ")})`;
}

/** `CSlotWindow::__CreateSlotEnableEffect`'s thirteen frames
 *  (`PythonSlotWindow.cpp:1292-1305`). */
export const SLOT_ACTIVE_EFFECT_FRAMES = 13;

/** `CAniImageBox`'s default `m_byDelay` of 4 updates a frame
 *  (`PythonWindow.cpp:1486`, `:1560-1575`), one update a rendered frame at the
 *  60 Hz a browser paints at: 52 frames. */
export const SLOT_ACTIVE_EFFECT_PERIOD_MS = (SLOT_ACTIVE_EFFECT_FRAMES * 4 * 1000) / 60;

const slotActiveFrame = (index: number): string =>
  `url("${TEXTURE_ART}/public/slotactiveeffect/${String(index).padStart(2, "0")}.png")`;

/** The sprite `CSlotWindow::OnRender` draws over an active slot, at the slot's
 *  own corner, in `RENDERING_MODE_SCREEN` (`PythonSlotWindow.cpp:1090-1096`,
 *  `:1306`). Any window that shows slots appends this to its style sheet. */
export const SLOT_ACTIVE_EFFECT_CSS = `
.slot-active-effect {
  position: absolute;
  inset: 0;
  pointer-events: none;
  mix-blend-mode: screen;
  background: ${slotActiveFrame(0)} 0 0 / 100% 100% no-repeat;
  animation: slot-active-effect ${String(SLOT_ACTIVE_EFFECT_PERIOD_MS)}ms step-end infinite;
}
@keyframes slot-active-effect {
${Array.from({ length: SLOT_ACTIVE_EFFECT_FRAMES }, (_, i) =>
    `  ${String((100 * i) / SLOT_ACTIVE_EFFECT_FRAMES)}% { background-image: ${slotActiveFrame(i)}; }`).join("\n")}
}
`;

/** Put the active sprite on `cell` or take it off: `ActivateSlot` and
 *  `DeactivateSlot` (`PythonSlotWindow.cpp:509-530`). */
export function setSlotActive(cell: HTMLElement, active: boolean): void {
  const effect = cell.querySelector<HTMLElement>(":scope > .slot-active-effect");
  if (!active) {
    effect?.remove();
    return;
  }
  if (effect === null) cell.append(elem(cell.ownerDocument, "span", "slot-active-effect"));
}
